<template>
  <div>
    <vs-popup
      class="rm-inventory-log-popup"
      id="popup"
      :title="`${code} LOGS`"
      :active.sync="open"
      :buttons-hidden="true"
    > 
      <vx-card no-shadow>

        <vs-table class="my-8" hoverFlat stripe :data="inventory_logs" :max-items="(meta.per_page) ? meta.per_page : 10">
          <template slot="thead">
            <vs-th width="25%">DATE/TIME</vs-th>
            <vs-th width="25%">EVENT TYPE</vs-th>
            <vs-th width="50%">DONE BY</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr v-for="(tr_item, indextr) in data" :key="indextr">

              <vs-td>
                {{ __dateTimeFormatter(tr_item.created_at) }}
              </vs-td>

              <vs-td>
                {{ tr_item.event }}
              </vs-td>

              <vs-td>
                {{ tr_item.causer ? tr_item.causer.name : '' }}
              </vs-td>

              <!-- EXPAND -->
              <template slot="expand">
                <div class="con-expand-users w-4/5">

                  <div v-if="tr_item.properties">

                    <vs-table noDataText="" class="w-full">
                      <template slot="thead">
                        <vs-th>CHANGED FIELD</vs-th>
                        <vs-th>PREVIOUS VALUE</vs-th>
                        <vs-th>NEW VALUE</vs-th>
                      </template>

                      <template>
                        <vs-tr
                          v-for="(row, i) in buildDiffRows(tr_item.properties)"
                          :key="i"
                        >
                          <vs-td>{{ row.field }}</vs-td>
                          <vs-td>{{ row.old }}</vs-td>
                          <vs-td>{{ row.new }}</vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>

                  </div>

                </div>
              </template>

            </vs-tr>
          </template>

        </vs-table>
        <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5">
            </vs-pagination>

      </vx-card>
    </vs-popup>
  </div>
</template>

<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";
const ActivityLogRepository = RepositoryFactory.get("activity");

import ErrorMessages from "@/mixins/ErrorMessages";
import successMessage from "@/mixins/SuccessMessage";

import { defaultPagination, perPageList } from "@/constants/config";

export default {
  name: "ViewSalesOrderLogPopUp",

  mixins: [ErrorMessages, successMessage],

  data() {
    return {
      inventory_logs: [],
      open: false,
      object_id: "",
      code: "",
      page : 1,
      total: 0,
      meta : {
        total: 0,
        last_page: 0,
        per_page: defaultPagination
      },
      sort : '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
    };
  },

  methods: {
    async openPopup(object_id, code = "") {
      this.object_id = object_id;
      this.code = code;
      this.open = true;
      await this.fetchLogs();
    },

    async fetchLogs() {
      const response = await ActivityLogRepository.viewSalesOrderLogs(this.object_id, this.page, this.perPage);
      const result = response && response.data ? response.data : {};
      this.inventory_logs = result.data ? result.data : [];
      this.meta = result.meta
    },

    /* =============================
       DIFF ENGINE
    ============================== */

    buildDiffRows(properties) {
      if (!properties || (!properties.old && !properties.new)) return [];

      const oldFlat = this.flattenObject(properties.old || {});
      const newFlat = this.flattenObject(properties.new || {});

      const keys = new Set(
        Object.keys(oldFlat).concat(Object.keys(newFlat))
      );

      return Array.from(keys)
        .map(k => {
          return {
            field: this.prettyPath(k),
            old: this.displayValue(oldFlat[k]),
            new: this.displayValue(newFlat[k])
          };
        })
        .filter(r => r.old !== r.new);
    },

    flattenObject(obj, parent, res) {
      parent = parent || "";
      res = res || {};

      if (!obj) return res;

      Object.keys(obj).forEach(key => {
        const value = obj[key];
        const path = parent ? parent + "." + key : key;

        if (Array.isArray(value)) {
          value.forEach((v, i) => {
            var label = this.extractLabel(v);
            var segment = label ? "(" + label + ")" : "[" + i + "]";
            var nextPath = path + "." + segment;

            if (typeof v === "object" && v !== null) {
              this.flattenObject(v, nextPath, res);
            } else {
              res[nextPath] = v;
            }
          });
        } else if (typeof value === "object" && value !== null) {
          this.flattenObject(value, path, res);
        } else {
          res[path] = value;
        }
      });

      return res;
    },

    extractLabel(obj) {
      if (!obj || typeof obj !== "object") return "";

      return (
        obj.log_label ||
        // obj.code ||
        // obj.name ||
        // obj.description ||
        // obj.title ||
        // obj.label ||
        ""
      );
    },

    prettyPath(path) {
      return path
        .replace(/\.\(/g, " → ")
        .replace(/\)\./g, " → ")
        .replace(/\./g, " → ")
        .replace(/\(/g, "")
        .replace(/\)/g, "")
        .replace(/_/g, " ")
        .replace(/\b\w/g, function(l) {
          return l.toUpperCase();
        });
    },

    displayValue(val) {
      if (val === undefined || val === null || val === "") return "—";

      if (typeof val === "object") {
        return JSON.stringify(val);
      }

      return String(val);
    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
    handleChangePage(page) {
      this.page = page;
      this.fetchLogs()
    },
  },
  watch : {
    page(){
      this.fetchLogs()
    },
    perPage() {
      this.fetchLogs()
    },
  },
};
</script>

<style scoped>
.rm-inventory-log-popup >>> .vs-popup {
  min-width: 70% !important;
}
</style>
